export function tryParseJSON<T = unknown>(data: string): T | null {
  if (typeof data !== 'string') return null;
  if (!data.trim().startsWith('{') || !data.trim().endsWith('}')) return null;

  try {
    return JSON.parse(data) as T;
  } catch {
    return null;
  }
}
